import React from "react";
import Reveal from "../components/ui/Reveal";
import SEO from "../components/seo/SEO";

export default function PrivacyPolicyPage() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="CampusGenie Privacy Policy. How we collect, use, and protect your personal information when you use our platform."
        url="/privacy"
      />

      <section className="legal-page-hero">
        <div className="container">
          <Reveal>
            <span className="eyebrow">Legal</span>
            <h1 className="heading-1" style={{ maxWidth: "18ch", margin: "0 auto 16px" }}>
              Privacy Policy
            </h1>
            <p className="body-base" style={{ textAlign: "center", maxWidth: "520px", margin: "0 auto" }}>
              Effective: January 2025 · Last modified: January 2025
            </p>
          </Reveal>
        </div>
      </section>

      <section className="section section-sm section-alt">
        <div className="container">
          <Reveal>
            <article className="legal-prose">
              <section>
                <h2 className="heading-4">Introduction</h2>
                <p className="body-base">
                  This Privacy Policy explains how CampusGenie collects, uses, and discloses your personal information when
                  you use our platform.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Data collection</h2>
                <h3 className="legal-prose-sub">Information we collect</h3>
                <p className="body-base">
                  We collect information that you provide to us directly, such as when you create an account, engage in
                  learning activities, or interact with our services.
                </p>
                <h3 className="legal-prose-sub">Automatically collected information</h3>
                <p className="body-base">
                  We may also collect information automatically when you use CampusGenie, such as device information, IP
                  address, and usage patterns.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Data usage</h2>
                <h3 className="legal-prose-sub">How we use your information</h3>
                <p className="body-base">
                  We use the information we collect to provide, maintain, and improve our services, personalize your
                  experience, and communicate with you.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Data sharing</h2>
                <h3 className="legal-prose-sub">Third-party services</h3>
                <p className="body-base">
                  We may share your information with trusted third-party service providers who perform services on our
                  behalf, such as data storage and customer support.
                </p>
                <h3 className="legal-prose-sub">Legal obligations</h3>
                <p className="body-base">
                  We may disclose your information if required by law or in response to a valid request by public authorities.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Your rights</h2>
                <p className="body-base">
                  You have the right to access, correct, or delete your personal information, as well as to object to
                  certain processing activities.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Data security</h2>
                <p className="body-base">
                  We take appropriate measures to protect your information from unauthorized access, use, or disclosure.
                  However, no system is completely secure.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Changes to this policy</h2>
                <p className="body-base">
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the
                  updated policy on our website.
                </p>
              </section>

              <section>
                <h2 className="heading-4">Contact us</h2>
                <p className="body-base">
                  If you need support, download the CampusGenie app, then contact support or submit a ticket through the
                  app.
                </p>
              </section>
            </article>
          </Reveal>
        </div>
      </section>
    </>
  );
}
